/**
 * TagRegisterPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  InputFormTable,
  SelectDepth,
  Table,
} from 'components';
import { Select, Input, Button, Avatar } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';

const depthItem = [1, 2, 3, 4, 5].map((_i1) => ({
  key: `${_i1}`,
  title: `대분류 ${_i1}`,
  children: [1, 2, 3, 4, 5].map((_i2) => ({
    key: `${_i1}-${_i2}`,
    title: `중분류 ${_i1}-${_i2}`,
    children: [1, 2, 3, 4, 5].map((_i3) => ({
      key: `${_i1}-${_i2}-${_i3}`,
      title: `중소분류 ${_i1}-${_i2}-${_i3}`,
      children: [1, 2, 3, 4, 5].map((_i4) => ({
        key: `${_i1}-${_i2}-${_i3}-${_i4}`,
        title: `소분류 ${_i1}-${_i2}-${_i3}-${_i4}`,
      })),
    })),
  })),
}));

const TagRegisterPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedTag, setSelectedTag] = useState({});

  /* ===== VARIABLE ===== */
  let tags = [];
  for (let i = 0; i < 100; i++) {
    tags.push({
      id: i,
      tag: `태그 ${i + 1}`,
      created_at: new Date(),
      updated_at: new Date(),
      is_show: 'Y',
      product: 51331,
    });
  }

  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    tag: {
      border: '1px solid #70737C',
      borderColor: 'rgba(112, 115, 124, 0.2)',
      background: 'transparent',
      color: 'var(--black-color)',
      fontWeight: 400,
      borderRadius: 4,
      padding: '2px 10px',
      display: 'inline-block',
      margin: '0px 4px 4px 0px',
      cursor: 'pointer',
    },
  };

  const form1 = [
    {
      label: '태그 명',
      required: true,
      form: [
        {
          input: <Input size="large" placeholder="태그 입력" />,
          count: true,
          maxLength: 10,
        },
      ],
    },
    {
      label: '노출 여부',
      required: true,
      form: [
        {
          input: (
            <Select
              size="large"
              value={'노출'}
              options={[
                { label: '노출', value: '노출' },
                { label: '노출안함', value: '노출안함' },
              ]}
              placeholder="노출여부를 선택하세요."
            />
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 5; i++) {
    newData.push({
      no: i + 1,
      카테고리: '커피/원두',
      상품코드: `0000000`,
      img: <Avatar size={50} shape="square" icon={<PictureOutlined />} />,
      name: '[과테말라] 디카페인 200g',
      price: 20000,
      sale: 500,
      수량: 57400,
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>태그 등록/수정</Title>

          {/* 태그 생성 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>태그 생성</Title>
            <InputFormTable form={form1} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 20,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ background: 'var(--primary-color)' }}
              >
                태그 생성
              </Button>
            </div>
          </Content>
          {/* 태그 생성 끝 */}

          {/* 태그 상품 등록 */}
          <Row gutter={[10, 10]}>
            <Col x={6}>
              <Content
                maxWidth={'100%'}
                padding={20}
                borderRadius={4}
                style={{ height: '100%' }}
              >
                {tags.map((_item, _index) => (
                  <span
                    style={{
                      ...styles.tag,
                      borderColor:
                        selectedTag.id === _item.id
                          ? 'var(--primary-color)'
                          : 'rgba(112, 115, 124, 0.2)',
                      background:
                        selectedTag.id === _item.id
                          ? 'var(--primary-color)'
                          : 'transparent',
                      color:
                        selectedTag.id === _item.id
                          ? '#FFFFFF'
                          : 'var(--black-color)',
                      fontWeight: selectedTag.id === _item.id ? 600 : 400,
                      margin: '0px 10px 10px 0',
                    }}
                    onClick={() =>
                      setSelectedTag((prev) =>
                        prev.id === _item.id ? {} : { ..._item },
                      )
                    }
                  >
                    #{_item.tag}
                  </span>
                ))}
              </Content>
            </Col>
            <Col x={18}>
              <Content
                maxWidth={'100%'}
                padding={20}
                borderRadius={4}
                style={{ height: '100%' }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}
                >
                  <div style={{ minWidth: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>상품 명</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Input
                      size="large"
                      style={{ ...styles.form.input.large, width: 175 }}
                      placeholder="상품 명을 입력해주세요"
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}
                >
                  <Select
                    size="large"
                    options={[]}
                    placeholder={'카테고리 검색으로 변경'}
                    style={{ ...styles.form.input.large, width: 175 }}
                  />
                  <Input
                    size="large"
                    placeholder={'카테고리명을 입력해주세요'}
                    style={{ ...styles.form.input.large, width: 175 }}
                  />
                </div>
                <SelectDepth
                  items={depthItem}
                  onSelect={(data) => {}}
                  onFinish={({ title }) => console.log('finish', title)}
                />
                <Table
                  data={newData}
                  isChecked
                  columns={[
                    {
                      title: 'No',
                      key: 'no',
                      width: 10,
                    },
                    {
                      title: '카테고리',
                      key: '카테고리',
                    },
                    {
                      title: '상품코드',
                      key: '상품코드',
                    },
                    {
                      title: '상품 이미지',
                      key: 'img',
                      width: 50,
                    },
                    {
                      title: '상품명',
                      key: 'name',
                    },
                    {
                      title: '판매가',
                      key: 'price',
                      render: (item) => stringToMoneyFormat(item, '원'),
                    },
                    {
                      title: '할인가',
                      key: 'sale',
                      render: (item) => stringToMoneyFormat(item, '원'),
                    },
                    {
                      title: '수량',
                      key: '수량',
                      render: (item) => stringToMoneyFormat(item, '개'),
                    },
                  ]}
                  layoutStyle={{ marginTop: 20 }}
                />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 20,
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    style={{ background: 'var(--primary-color)' }}
                  >
                    상품 등록
                  </Button>
                </div>
              </Content>
            </Col>
          </Row>
          {/* 태그 상품 등록 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default TagRegisterPresenter;
